import React, { useState } from 'react';
import styled from 'styled-components';

const Input = ({ name, placeholder, onChange }) => {
  const [inputValue, setInputValue] = useState('');
  const changeHandler = (e) => {
    setInputValue(e.target.value);
    onChange && onChange(e);
  };
  return (
    <InputBox type="text" name={name} placeholder={placeholder} onChange={changeHandler} />
  );
};

const InputBox = styled.input`
  width: 100%;
  max-height: 65px;
  padding:20px;
  border-radius: 3px;
  border: 0.5px solid #fff; 
  background-color: transparent;
  color:#fff;
  opacity: 0.6;
  &:focus-visible{
    opacity: 1;
  }
`;

export default Input;